import React from 'react';
import { CheckCircleTwoTone, CloseCircleTwoTone, EyeOutlined } from '@ant-design/icons'

const columns = [
  {
    title: 'ผู้ใช้งาน',
    render: (user) => (<>
      {<div className={user.fullname ? '' : 'text-muted'}>{user.fullname || 'ไม่ทราบชื่อ'}</div>}
      {user.phone}
    </>)
  },
  {
    title: 'พาร์ทเนอร์',
    dataIndex: 'partner_name',
  },
  {
    title: 'โนบูโร สกอร์',
    dataIndex: 'noburo_score',
  },
  {
    title: 'ข้อมูล DOPA',
    render: ({ dopa }) => (<>
      {
        dopa ?
          <CheckCircleTwoTone twoToneColor="#52c41a" /> :
          <CloseCircleTwoTone twoToneColor="#eb2f96" />
      }
    </>)
  },
  {
    title: 'ข้อมูล HR',
    render: ({ hr }) => (<>
      {
        hr ?
          <CheckCircleTwoTone twoToneColor="#52c41a" /> :
          <CloseCircleTwoTone twoToneColor="#eb2f96" />
      }
    </>)
  },
  {
    title: 'ข้อมูลที่อยู่',
    render: ({ address }) => (<>
      {
        address ?
          <CheckCircleTwoTone twoToneColor="#52c41a" /> :
          <CloseCircleTwoTone twoToneColor="#eb2f96" />
      }
    </>)
  },
  {
    title: 'ข้อมูลแบงก์',
    render: ({ bank_book }) => (<>
      {
        bank_book ?
          <CheckCircleTwoTone twoToneColor="#52c41a" /> :
          <CloseCircleTwoTone twoToneColor="#eb2f96" />
      }
    </>)
  },
  {
    title: 'ข้อมูลผู้ติดต่อ',
    render: ({ contact_persons }) => (<>
      {
        contact_persons ?
          <CheckCircleTwoTone twoToneColor="#52c41a" /> :
          <CloseCircleTwoTone twoToneColor="#eb2f96" />
      }
    </>)
  },
  {
    title: 'เข้าร่วมเมื่อ',
    dataIndex: 'created_at',
  },
  {
    title: '',
    render: (user) => (
      <a href={`/admins/users/${user.id}/scores`}>
        <EyeOutlined />
      </a>
    )
  }
];

export { columns }
